import { getFrontendConfigLoader } from '@doxyme/config';
import { loadSegment } from '../../features/tracking/trackers/segment';

/**
 * Initializes tracking for Frontegg auth pages
 * These pages need Segment but should not load Intercom
 * @returns {void}
 */
export const initializeFronteggPage = (): void =>
  typeof window !== 'undefined' ? initFronteggPage() : undefined;

const initFronteggPage = (): void => {
  loadSegment({
    apiKey: getFrontendConfigLoader().get('SEGMENT_API_KEY') as string,
    src: getFrontendConfigLoader().get('SEGMENT_SRC') as string,
    isProvider: false,
  });
};
